var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.566 24.85"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.283 11.907a3.624 3.624 0 113.624-3.624 3.628 3.628 0 01-3.624 3.624M8.283 0A8.292 8.292 0 000 8.283c0 4.394 7.531 15.849 7.851 16.333a.517.517 0 00.864 0c.321-.485 7.851-11.939 7.851-16.333A8.292 8.292 0 008.283 0",
    fill: "currentcolor",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "6026eacfaffa4b2952fcb79a59d61bf6.svg";
export { SvgLocationPin as ReactComponent };